module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-actions",
    attrs: {
      "id": "user-log"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "log_actions"
  }, [
    [_c('vuetable', {
      ref: "vuetable",
      attrs: {
        "api-url": "/api/logs/bookings",
        "http-options": _vm.header,
        "fields": _vm.columns,
        "per-page": 10,
        "append-params": _vm.moreParams,
        "pagination-path": ""
      },
      on: {
        "vuetable:pagination-data": _vm.onPaginationData
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "vuetable-pagination ui basic segment grid"
    }, [_c('vuetable-pagination-info', {
      ref: "paginationInfo"
    }), _vm._v(" "), _c('vuetable-pagination', {
      ref: "pagination",
      on: {
        "vuetable-pagination:change-page": _vm.onChangePage
      }
    })], 1)]
  ], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("User Actions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5387760","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/UserActions.vue
// module id = 959
// module chunks = 24